import COLORS from '../../styles/colors'
import { SlideDefinition } from './types'

export const DEFAULT_TRANSITION_MS = 700

export const HERO_CAROUSEL_CONFIG = {
  disableAutoSlideChange: true,
}

export const slideConfig: SlideDefinition[] = [
  {
    id: 'bookshelf',
    title: 'The Bookshelf',
    description:
      'On the Bookshelf you can explore a variety of Topics and reserve a spot for an upcoming Reading',
    durationMs: 7000,
    background: COLORS.beige,
    data: {
      startOffsetPercent: 0,
      panDistancePercent: 100,
      panStartDelayMs: 750,
    },
  },
  {
    id: 'unjudge',
    title: '',
    description: '',
    durationMs: 10000,
    background: COLORS.greyDark,
    data: {
      imageSrc: '/hero_unjudge.png',
    },
  },
]
